// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { CompanyFundsHoldingsOverlapModule } from './app.module';
bootstrapAppModule(CompanyFundsHoldingsOverlapModule);
